import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = { class: "fs-18 text-gray" }
const _hoisted_10 = {
  key: 1,
  class: "py-5 text-center"
}
const _hoisted_11 = { class: "fs-18 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_Divider = _resolveComponent("Divider")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_RoomObjectGroup = _resolveComponent("RoomObjectGroup")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogConfigureRoom = _resolveComponent("DialogConfigureRoom")
  const _component_DialogConfirmDeleteRoom = _resolveComponent("DialogConfirmDeleteRoom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.$t("AppResource.Structure")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.currentRoom.name), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            class: "p-button-rounded p-button-raised p-button--m",
            onClick: _ctx.toggleAddRoomObjectDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("plantDetail.addObjects")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.roomEditEnabled)
            ? (_openBlock(), _createBlock(_component_Divider, {
                key: 0,
                layout: "vertical"
              }))
            : _createCommentVNode("", true),
          (_ctx.roomEditEnabled)
            ? (_openBlock(), _createBlock(_component_ElDropdown, {
                key: 1,
                trigger: "click",
                placement: "bottom-end",
                "popper-class": "el-dropdown__popper el-dropdown--context"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleConfigureRoomDialog }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_6, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      (!_ctx.hasObjects)
                        ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                            key: 0,
                            onClick: _ctx.toggleDeleteRoomConfirm
                          }, {
                            default: _withCtx(() => [
                              _createVNode("button", _hoisted_7, [
                                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                            ,
                        "aria-label": "icon-ellipsis-v"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.ConfigurationToEnd")) + ": " + _toDisplayString(_ctx.countConfigurationToEnd), 1)
    ]),
    _createVNode(_component_ElScrollbar, { class: "room-object-list" }, {
      default: _withCtx(() => [
        (_ctx.hasObjects)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.roomObjects, (roomObject) => {
              return (_openBlock(), _createBlock(_component_RoomObjectGroup, {
                key: roomObject.id,
                name: roomObject.id,
                room: _ctx.currentRoom,
                "room-object": roomObject,
                "hide-config": !_ctx.roomConfigEnabled,
                "disable-actions": !_ctx.roomObjectDeleteEnabled,
                onDeleteObject: ($event: any) => (_ctx.handleDeleteObject(roomObject)),
                class: "mb-3"
              }, null, 8, ["name", "room", "room-object", "hide-config", "disable-actions", "onDeleteObject"]))
            }), 128))
          : (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("h1", null, _toDisplayString(_ctx.$t("AppResource.NoDevices")), 1),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.AddNewNew")), 1)
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_DialogConfigureRoom, {
      "is-visible": _ctx.isVisibleDialogConfigureRoom,
      "plant-id": _ctx.currentPlant.desktopId,
      "room-id": _ctx.roomId,
      room: _ctx.currentRoom,
      onHideDialog: _ctx.toggleConfigureRoomDialog
    }, null, 8, ["is-visible", "plant-id", "room-id", "room", "onHideDialog"]),
    _createVNode(_component_DialogConfirmDeleteRoom, {
      "is-visible": _ctx.isVisibleDeleteRoomConfirm,
      onHideDialog: _ctx.toggleDeleteRoomConfirm,
      onOkDialog: _ctx.deleteRoom
    }, null, 8, ["is-visible", "onHideDialog", "onOkDialog"])
  ], 64))
}